import { createToastHooks, GlobalToastManager } from '@talos/kyoko';
import type { AppInboxToastStateItem } from './types';

const appInboxManagerUI = new GlobalToastManager<AppInboxToastStateItem>('appInbox');
const appInboxHooks = createToastHooks(appInboxManagerUI);
export const useAppInboxToasts = () => appInboxHooks;
